import { IconArrowRight } from './IconArrowRight'

export default IconArrowRight
